import { type Enum } from '@webapp/infrastructure/types/Enum'

export const PrimaryCategoryKeys = {
  CONFIG_LIST: 'config-list',
  CONFIG_DETAIL: 'config-detail',
  SECONDARY_CATEGORIES: 'secondary-categories',
  CONFIG_USERS: 'config-users',
} as const

export type PrimaryCategoryKeysEnum = Enum<typeof PrimaryCategoryKeys>
